import { Controller } from "@hotwired/stimulus"

// Toggles a masked secret between hidden (the maskedValue, e.g. "y-bovg…ljlFd")
// and the revealed full value, swapping the trigger label between "Reveal" and
// "Hide". Copy buttons are independent — they always copy the real value, so
// revealing only affects what's shown on screen.
//
//   <div data-controller="reveal"
//        data-reveal-masked-value="y-bovg…ljlFd"
//        data-reveal-full-value="<%= secret %>">
//     <code data-reveal-target="output"></code>
//     <button data-action="reveal#toggle"><span data-reveal-target="label">Reveal</span></button>
//   </div>
export default class extends Controller {
  static targets = ["output", "label"]
  static values = {
    masked: String,
    full: String,
    revealed: { type: Boolean, default: false },
  }

  connect() {
    this.render()
  }

  toggle() {
    this.revealedValue = !this.revealedValue
    this.render()
  }

  render() {
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = this.revealedValue
        ? this.fullValue
        : this.maskedValue
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = this.revealedValue ? "Hide" : "Reveal"
    }
  }
}
